//Modules
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

//Components
import { MenuPage } from '../menuPage/MenuPage';
import { useTransition } from '../globalComponents/PageTransitionContext';

//Styles
import '../globalComponents/NavigationBar.css';
import './HeroPage.css'
import logo from '../images/logo.webp';
import '../globalComponents/NavigationBar.css'

export const HeroNavigationBar = ({ className }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation(); 
    const { handleNavigation } = useTransition();

    const toggleMenu = () => {
        setMenuOpen(prevState => !prevState);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    const navItems = [
        { name: 'Home', path: '/' },
        { name: 'About Me', path: '/AboutMe' },
        { name: 'Other Stuff', path: '/OtherStuff' },
        { name: 'Contact', path: '/ContactMe' },
    ];

    return(
        <div className="navbar-wrapper">
            <div className="hero-navbar">
                <header className="hero-navigation-list">
                    {navItems.map((item, index) => {
                        const isActive = location.pathname === item.path; 
                        return (
                            <div className="hero-navbar-item" key={index}>
                                <Link
                                    className={`body desktop-menu-item ${isActive ? 'active' : ''}`} 
                                    to={item.path}
                                    data-cursor-none
                                    onClick={(e) => {
                                        if (!isActive) {
                                            e.preventDefault();
                                            handleNavigation(item.path);
                                        }
                                    }}
                                    style={isActive ? { pointerEvents: 'none' } : {}} 
                                >
                                    {item.name}
                                </Link>
                            </div>
                        );
                    })}
                    <img className="hero-logo" src={logo} alt="logo" />
                </header>
            </div>

            <div className="mobile-navbar">  
                <div className="logo">
                    <img src={logo} alt="Logo" />
                </div>  
                <button onClick={toggleMenu} className="navbar-menu heading-5">  
                    {menuOpen ? 'Close' : 'Menu'}
                </button>  
                {menuOpen && <MenuPage onClose={closeMenu} />}
            </div>
        </div>
    )
};